import { Property } from "../../../businessFoundation/MetaClassData/MetaClassDataList/MetaClassDataModel";
import { Address } from "../../AddressManager/model/address";
import { ContactNote } from "../../ContactNoteManager/model/ContactNote";
import { SortDirection } from "@episerver/ui-framework";

export interface ContactListViewModel {
    Contacts: Contact[];
    PagingInfo: PagingInfo;
}

export interface Contact {
    primaryKeyId: string | null;
    fullName: string;
    firstName: string;
    middleName: string;
    lastName: string;
    email: string;
    ownerId: string | null;
    customerGroup: string;
    customerGroupId: string | null;
    lastOrder: string;
    preferredCurrencyId: string | null;
    preferredLanguageId: string | null;
    preferredShippingAddressId: string | null;
    preferredBillingAddressId: string | null;
    registrationSource: string;
    userId: string;
    extendedProperties: Property[];
    contactNotes: ContactNote[];
    addresses: Address[];
    created: string;
    modified: string;
    acceptMarketingEmail: boolean;
}

export interface PagingInfo {
    StartRow: string;
    RowsPerPage: string;
    TotalRowCount: string;
}

export interface EnumData {
    id: number;
    name: string;
    type: string;
    orderId: number;
}

export interface EnumForm {
    open: boolean;
    title: string;
    data: EnumData;
}

export interface ConfirmDialog {
    open: boolean;
    title: string;
    message: string;
    contactIds: string[];
}

export interface KeyValueOption {
    key: string;
    value: string;
}

export enum ServerSortType {
    Asc,
    Desc,
}

export interface ListParams {
    sortField: string;
    sortType: ServerSortType;
    startIndex: number;
    recordsToRetrieve: number;
    type: ContactsType;
}

export interface SearchParams {
    query: string;
    sortField: string;
    sortType: ServerSortType;
    startIndex: number;
    recordsToRetrieve: number;
    type: ContactsType;
}

export interface SearchAssignmentsParams {
    query: string;
    sortField: string;
    sortType: ServerSortType;
    startIndex: number;
    recordsToRetrieve: number;
    userId: string;
}

export interface DeleteParams {
    contactIds: string[];
    query: string;
    sortField: string;
    sortType: ServerSortType;
    startIndex: number;
    recordsToRetrieve: number;
    type: ContactsType;
}

export enum ContactTab {
    Details,
    Addresses,
    ContactNote,
    AccountAssignments
}

export interface CustomerAccount {
    open: boolean;
    userId: number;
    username: string;
    password: string;
    email: string;
    description: string;
    approved: boolean;
    contactId: string;
}

export enum ContactsType {
    Users = 5, 
    Accounts = 4,
    Contacts = 1
}

export enum ContactType {
    User = 5, 
    Account = 4,
    Contact = 1
}

export interface UpdateContactsParams {
    contactIds: string[];
    userId: string;
}


export interface ResetTwoFactorParams {
    email: string;
}


export interface ApproveCmsUserParams {
    email: string;
    isApproved: boolean;
}

export interface PaginationModel {
    startRow: number;
    totalRowCount: number;
    rowsPerPage: number;
    rowsPerPageOptions: number[];
    searchInput: string;
}

export interface SortModel {
    sortedColumn: string;
    sortDirection: SortDirection;
}

export const UserExtendedProps : string[] = [ "Active", "TemporaryPasswordExpiration", "PasswordExpiration", "HasBraintreeCustomerId" ]

export const AccountExtendedProps : string[] = ["Active", "AllowWebOrder", "HasBraintreeCustomerId", "Code", "SalesOrganization", "PriceGroup", "DistributionChannel", "SAPCustomerGroup", "SalesTerritory", 
"RestrictItemsFlag", "FreeShippingFlag", "CreditStop", "FreeShipThreshold", "OrderMinimum", "PaymentTerms", "IndustryCode", "IndustryCode1", "CustomerTaxClassification"  ]